(function () {
  const EDGES = [33.5, 35, 37, 40, 42];
  const SIZES = ['S', 'M', 'L', 'XL', '2XL', '3XL'];
  const GARMENT_WIDTHS = { S: 68, M: 73, L: 78, XL: 83, '2XL': 88, '3XL': 96 };

  function recommendedSize(bandUs, cupStep) {
    const bust = Number(bandUs) + Number(cupStep);
    let index = 0;
    while (index < EDGES.length && bust >= EDGES[index]) index += 1;

    const bandCm = Number(bandUs) * 2.54;
    while (index < SIZES.length - 1 && GARMENT_WIDTHS[SIZES[index]] * 1.25 < bandCm) index += 1;
    return SIZES[index];
  }

  function initialise(root) {
    if (root.dataset.clSizeReady === 'true') return;
    root.dataset.clSizeReady = 'true';

    let selectedBand = '';
    let selectedBandUs = '';
    let selectedUnderbust = '';
    let selectedCup = '';
    let selectedCupStep = '';
    const result = root.querySelector('[data-cl-size-result]');
    const value = root.querySelector('[data-cl-size-value]');
    const note = root.querySelector('[data-cl-size-note]');
    const action = root.querySelector('[data-cl-size-action]');
    const cupHint = root.querySelector('[data-cl-cup-hint]');

    function bustRange(bandFr, cupStep) {
      const minimum = Number(bandFr) - 7 + (Number(cupStep) * 3);
      return `${minimum}–${minimum + 2}`;
    }

    function updateCupMeasurements() {
      root.querySelectorAll('[data-cl-cup]').forEach((button) => {
        const measure = button.querySelector('[data-cl-cup-measure]');
        if (!measure) return;
        measure.textContent = selectedBand ? `${bustRange(selectedBand, button.dataset.clCupStep)} cm` : '—';
      });

      if (cupHint) {
        cupHint.textContent = selectedBand
          ? `Pour la taille ${selectedBand}, choisissez le bonnet correspondant à votre tour de poitrine.`
          : 'Choisissez d’abord votre tour de dos pour afficher le tour de poitrine correspondant à chaque bonnet.';
      }
    }

    function select(selector, active) {
      root.querySelectorAll(selector).forEach((button) => {
        const pressed = button === active;
        button.classList.toggle('is-selected', pressed);
        button.setAttribute('aria-pressed', String(pressed));
      });
    }

    function update() {
      if (!selectedBand || !selectedCup) {
        result.hidden = true;
        return;
      }
      const size = recommendedSize(selectedBandUs, selectedCupStep);
      const selectedBust = bustRange(selectedBand, selectedCupStep);
      value.textContent = size;
      note.textContent = `Taille française ${selectedBand}${selectedCup} · Tour de dos ${selectedUnderbust} cm · Tour de poitrine ${selectedBust} cm.`;
      action.textContent = `Choisissez ${size} ci-dessous lorsque vous sélectionnez vos coloris.`;
      result.hidden = false;
    }

    root.querySelectorAll('[data-cl-band]').forEach((button) => {
      button.addEventListener('click', () => {
        selectedBand = button.dataset.clBand;
        selectedBandUs = button.dataset.clBandUs;
        selectedUnderbust = button.dataset.clUnderbust;
        select('[data-cl-band]', button);
        updateCupMeasurements();
        update();
      });
    });

    root.querySelectorAll('[data-cl-cup]').forEach((button) => {
      button.addEventListener('click', () => {
        selectedCup = button.dataset.clCup;
        selectedCupStep = button.dataset.clCupStep;
        select('[data-cl-cup]', button);
        update();
      });
    });
  }

  function initialiseAll(scope) {
    scope.querySelectorAll('[data-cl-size-finder]').forEach(initialise);
  }

  document.addEventListener('DOMContentLoaded', () => initialiseAll(document));
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
